window.addEventListener('DOMContentLoaded', () => {

	let currentFilterButton = null;
	const filterButtons = document.querySelectorAll( '.brand-buttons .button[data-filter]' );
	const brands = [ ...document.querySelectorAll( '.brand-name' ) ].map( el => ({
			el,
			types: el.dataset.types.split( ',' )
	}) );

	filterButtons.forEach( f => {
			const type = f.dataset.filter;
			f.addEventListener( 'click', e => {
					if ( currentFilterButton && currentFilterButton.dataset.filter === type ) {
							currentFilterButton.classList.remove( 'active' );
							setFilter( null );
							currentFilterButton = null;
					} else {
							currentFilterButton?.classList.remove( 'active' );
							setFilter( type );
							f.classList.add( 'active' );
							currentFilterButton = f;
					}
			} );
	} );


	function setFilter( type ) {
			for (const brand of brands) {
					brand.el.classList.toggle( 'filtered', type ? !brand.types.includes(type) : false );
			}
	}

} );
